import {FEATURE_FLAGS} from '@packages/systems/feature-config/shared';
import {defineAbilityConfig} from '../system/defineAbilityConfig';

const overlayMiniToolbarAccess = {
  userTypes: {
    authorizedInDesigner: true,
  },
  workflows: {canvas: true, analyzeVisualView: true},
  siteModes: {design: true, edit: true},
} as const;

export const canAccessPopoverMiniToolbar = defineAbilityConfig([
  {
    ...overlayMiniToolbarAccess,
    featureFlags: {[FEATURE_FLAGS.BUILDING_BLOCKS_POPOVERS]: true},
  },
] as const);
